import React, { useState } from "react";
import { SetupModalProps } from "../../types";

const SetupModal: React.FC<SetupModalProps> = ({ isOpen, onClose, onSubmit }) => {
  const [dogName, setDogName] = useState("");
  const [dogImage, setDogImage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setDogImage(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!dogName.trim()) return;
    
    setIsSubmitting(true);
    try {
      await onSubmit(dogName.trim(), dogImage);
      onClose();
    } catch (error) {
      console.error("Error creating dog profile:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full">
        <div className="text-center mb-6">
          <div className="bg-gradient-to-br from-teal-400 to-teal-600 rounded-full p-4 inline-block mb-4">
            <span className="text-4xl text-white">🐾</span>
          </div>
          <h2 className="text-2xl font-bold">Welcome to SharedDog!</h2>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="text-center">
            <div className="w-24 h-24 mx-auto rounded-full bg-gray-200 flex items-center justify-center overflow-hidden mb-2">
              {dogImage ? (
                <img src={dogImage} alt="Dog" className="w-full h-full object-cover" />
              ) : (
                <span className="text-3xl">🐕</span>
              )}
            </div>
            <label className="inline-block bg-blue-500 text-white px-4 py-2 rounded-lg cursor-pointer hover:bg-blue-600">
              <input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                className="hidden"
              />
              Upload Photo
            </label>
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-2">What's your dog's name?</label>
            <input
              type="text"
              value={dogName}
              onChange={(e) => setDogName(e.target.value)}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
              placeholder="Enter your dog's name"
              required
            />
          </div>
          
          <button
            type="submit"
            disabled={isSubmitting || !dogName.trim()}
            className="w-full py-3 bg-gradient-to-r from-teal-400 to-teal-600 text-white rounded-lg hover:from-teal-500 hover:to-teal-700 disabled:opacity-50 font-semibold"
          >
            {isSubmitting ? "Setting up..." : "Get Started"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SetupModal;